import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AuthorizeRoute from '../api-authorization/AuthorizeRoute';

import { NewsletterList } from './NewsletterList';
import { NewsletterEditor } from './NewsletterEditor';
import { NewsletterPage } from './NewsletterPage';

function NewsletterRouter() {
	let match = useRouteMatch();

	return (
		<Switch>
			<AuthorizeRoute path={`${match.path}/list`} component={NewsletterList} />
			<AuthorizeRoute path={`${match.path}/add`} component={NewsletterEditor} />
			<AuthorizeRoute path={`${match.path}/edit/:id`} component={NewsletterEditor} />
			<AuthorizeRoute path={`${match.path}`} component={NewsletterPage} />
		</Switch>
	);
}

export default NewsletterRouter;